import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import Reveal from "../components/Reveal";
import { ArrowRight } from "@phosphor-icons/react";
import useSeo from "../lib/useSeo";
import { useT, usePick } from "../lib/i18n";

export default function Blog() {
  useSeo({
    title: "Journal | Yuva Ayurvedic Clinic Prayagraj — Ayurveda & Men's Wellness",
    absoluteTitle: true,
    description: "Articles and clinical notes from Yuva Ayurvedic Clinic Prayagraj — classical Ayurveda, men's sexual wellness, mardana shakti and living well. Trusted Ayurvedic insights since 2008.",
    keywords: "Ayurveda blog India, Men's sexual health blog India, Ayurvedic wellness Prayagraj, Mardana kamzori Ayurveda articles",
  });
  const t = useT();
  const pick = usePick();
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then(r => setPosts(r.data)).catch(() => {}); }, []);

  return (
    <div className="pb-24" data-testid="blog-page">
      <section className="py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <Reveal>
            <div className="overline">{t("blog.overline")}</div>
            <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-7xl mt-6 max-w-3xl leading-[0.95]">
              {t("blog.title")}
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="pb-20">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid md:grid-cols-12 gap-8">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.05} className={i === 0 ? "md:col-span-12" : "md:col-span-6 lg:col-span-4"}>
              <Link to={`/blog/${p.slug}`} className="group block" data-testid={`post-card-${p.slug}`}>
                <div className={`${i === 0 ? "aspect-[21/9]" : "aspect-[4/3]"} rounded-2xl overflow-hidden bg-ivory`}>
                  <img src={p.cover_image} alt={`${pick(p, "title")} — Yuva Ayurvedic Clinic Prayagraj journal`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" decoding="async"/>
                </div>
                <div className="mt-6">
                  <div className="overline">{p.category}</div>
                  <h2 className={`font-serif-display ${i === 0 ? "text-4xl sm:text-5xl" : "text-2xl"} mt-3 leading-tight group-hover:text-terracotta transition-colors`}>{pick(p, "title")}</h2>
                  <p className="mt-3 text-muted-foreground line-clamp-2">{pick(p, "excerpt")}</p>
                  <div className="mt-5 inline-flex items-center gap-2 text-sm uppercase tracking-[0.2em] text-terracotta"><span>{t("cta.read")}</span><ArrowRight size={14}/></div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
